export { default } from './AppFlavorDucks.js'
export * from './AppFlavorDucks.js'

